export default "__VITE_ASSET__DAjP_3PE__"